<template>
	<div 
		:class="[
			'hd-mod-frame-molecule-overview',
			'js-mod-frame-molecule-overview'
		]"
	>
		<base-image-svg
			class="hd-mod-frame-molecule-overview__svg"
			:source="require('!html-loader!../../assets/svgs/02-mod-frame-molecule-overview.svg')"
		/>
		<base-image-svg
			class="hd-mod-frame-molecule-overview__svg hd-mod-frame-molecule-overview__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/02-mod-frame-molecule-overview-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-molecule-overview {
		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			max-width: 700px;

			.tween-label,
			.tween-molecule {
				opacity: 0;
				transition: all 1s ease;
			}

			.tween-molecule {
				@include animation-float-mini();
			}
		}

		// Animation 
		&[data-state="animation-ready"] {
			:deep() svg {
				.tween-molecule { opacity: 1; }

				.tween-label {
					@include animation-frame-fade-in();

					&.tween-label-line-1, &.tween-label-text-1 { animation-delay: 0.25s;}
					&.tween-label-line-2, &.tween-label-text-2 { animation-delay: 0.5s; }
					&.tween-label-line-3, &.tween-label-text-3 { animation-delay: 0.75s; }
					&.tween-label-line-4, &.tween-label-text-4 { animation-delay: 1s; }
					&.tween-label-line-5, &.tween-label-text-5 { animation-delay: 1.25s; }
					&.tween-label-line-6, &.tween-label-text-6 { animation-delay: 1.5s; }
				}
			}
		}

		// Responsive 
		@include res-screen-small {
			:deep() svg {
				max-width: 550px;
			}
		}

		@include res-screen-x-small {
			:deep() svg {
				max-width: 450px;
				padding-top: 40px;
			}
		}

		@include res-screen-portrait {
			@include center-x();
			top: 140px;
			:deep() svg {
				max-width: 600px;
			}
		}

		@include res-screen-portrait-sm {
			top: 20px;
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}

			:deep() svg {
				max-width: 250px;
			}
		}
	}
</style>